import React from 'react';
import { Input, Modal, Button } from 'antd';

import Select from '../../common/Select';

const UsersModal = ({
  onOk,
  onClose,
  onUserIdChange,
  onUserPermissionsChange,
  onUserGroupsChange,
  user,
  groups,
  updating,
}) =>
  user && (
    <Modal
      className="users-editing-modal"
      title="User"
      wrapClassName="global-filter-modal"
      open={!updating}
      onOk={onOk}
      onCancel={onClose}
      footer={[
        <Button className="create-user_button" key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
        <Button className="cancel-modal_user_button" key="back" onClick={onClose}>
          Cancel
        </Button>,
      ]}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ flex: 1 }}>User ID</div>
          <div style={{ flex: 4 }}>
            <Input
              className="ant-input-border-bottom"
              id="user-id"
              value={user.userId}
              onChange={(e) => onUserIdChange(e.target.value)}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
          <div style={{ flex: 1 }}>Permissions</div>
          <div id="user_permission_select" style={{ flex: 4 }}>
            <Select
              className="ant-select-border-bottom"
              style={{ width: '100%' }}
              multi
              customizable
              onChange={onUserPermissionsChange}
              value={user.permissions}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
          <div style={{ flex: 1 }}>Groups</div>
          <div id="user_group_select" style={{ flex: 4 }}>
            <Select
              className="ant-select-border-bottom"
              style={{ width: '100%' }}
              multi
              customizable
              onChange={onUserGroupsChange}
              value={user.groups}
              values={groups.map((g) => g.groupId)}
            />
          </div>
        </div>
      </div>
    </Modal>
  );

export default UsersModal;
